import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { ExtraOptions, ICoreConfig, IDrawingAssets, IInnerDimensions, ISvgScales, SVGComponents, SvgNode } from '../core/culture-index-chart.model'
import { easeLinearAnimation, getGroupClassNames, getNodeRadius, getOneOfDotsType } from '../utils/d3-utils'

type DrawNodesArgs = ISvgScales & Pick<IInnerDimensions, 'innerHeight'> & Pick<IDrawingAssets, 'nodes'> & ExtraOptions
@Component({
  selector: 'culture-index-chart-nodes',
  standalone: true,
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CultureIndexChartNodesComponent {
  @Input({ required: true }) coreConfig!: ICoreConfig

  /**
   * Draws the Facilitator and Candidate Nodes
   */
  drawNodes(svg: SvgNode, args: DrawNodesArgs, loading?: boolean) {
    const { xScale, yScale, innerHeight, nodes, compare } = args
    const scale = (r: number, factor = 0.3) => (innerHeight / r) * factor

    const nodesGroup = svg.append('g')
    nodesGroup
      .selectAll('g')
      .data(nodes)
      .enter()
      .append('g')
      .attr('class', `${getOneOfDotsType(compare)}${SVGComponents.NODE}`)
      .append('circle')
      .attr('cx', node => xScale(node.x + 2 + 0.08))
      .attr('cy', node => yScale(node.y + 0.25))
      .attr('r', node => getNodeRadius(scale(node.radius), node.size) - 1.9)
      .attr('fill', 'transparent')
      .transition()
      .duration(300)
      .delay(400)
      .transition()
      .duration(300)
      .delay((_, i) => i * 400)
      .ease(easeLinearAnimation)
      .attr('r', node => getNodeRadius(scale(node.radius), node.size))
      .attr('fill', node => (loading ? '#e0e0e0' : node.color))
      .attr('stroke', node => (loading ? '#e0e0e0' : node.borderColor))
      .attr('stroke-width', 1)
      .style('cursor', 'pointer')
  }

  /**
   * Updates the Facilitator and Candidate Nodes
   */
  updateNodes(svg: SvgNode, args: DrawNodesArgs, loading?: boolean) {
    const { xScale, yScale, innerHeight, nodes, compare } = args
    const scale = (r: number, factor = 0.3) => (innerHeight / r) * factor

    const group = getGroupClassNames([SVGComponents.NODE], [getOneOfDotsType(compare)])[0]
    const circles = svg.selectAll(`${group} > circle`)

    if (circles.size() === 0) {
      this.drawNodes(svg, args, loading)
      return
    }

    circles
      .data(nodes)
      .transition()
      .duration(500)
      .attr('cx', node => xScale(node.x + 2 + 0.08))
      .attr('cy', node => yScale(node.y + 0.25))
      .attr('r', node => getNodeRadius(scale(node.radius), node.size))
      .attr('fill', node => (loading ? '#e0e0e0' : node.color))
      .attr('stroke', node => (loading ? '#e0e0e0' : node.borderColor))
  }
}
